import React, { useEffect, useState } from "react";
import { useHostStore } from "host/HostStore";
import Cookies from "js-cookie";
import { textConstants } from "../../../constants/textConstants";
import { workflowClient, hostClient, signupClient } from "../../../store/graphql/apollo/clients";
import { useGetThriveStackWorkflowSignupIdLazyQuery } from "../../../store/graphql/codegen/auto-gen/workflow";
import {
    useGetUserByEmailLazyQuery,
    useGetUserLazyQuery,
    useSendInviteeSignUpTrackEventLazyQuery
} from "../../../store/graphql/codegen/auto-gen/user";
import { endpoints } from "../../../endpoints";
interface ThriveStack {
    setUserId: (userId: string) => void;
    setSource: (source: string) => void;
}
declare global {
    interface Window {
      ThriveStack?: ThriveStack; 
      thriveStack?: ThriveStack
    }
  }

const EXPIRY_TIME = 100;
export const TokenVerificationV2 = () => {
    const { auth, setAuth } = useHostStore();
    const [valid, setValid] = useState<boolean>(true);
    const [getWorkflowId] = useGetThriveStackWorkflowSignupIdLazyQuery({
        client: workflowClient,
        fetchPolicy: "no-cache"
    });
    const [getUser] = useGetUserLazyQuery({
        client: hostClient,
        fetchPolicy: "no-cache"
    });

    const [getUserByEmail] = useGetUserByEmailLazyQuery({
        client: hostClient,
        fetchPolicy: "no-cache"
    });

    const [sendInviteeSignUpTrackEvent] = useSendInviteeSignUpTrackEventLazyQuery({
        client: signupClient,
        fetchPolicy: "no-cache"
    });

    const setHostAuthenticationState = () => {
        let updatedAuth = null;

        if (!auth) {
            updatedAuth = { isLoggedIn: true };
        } else {
            updatedAuth = { ...auth, isLoggedIn: true };
        }
        setAuth(updatedAuth);
    };

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const planId = urlParams.get("planId");
    const sourceProduct = urlParams.get("sourceProduct");

    async function APITrigger(data: any, response3: any, workflowId: string, returnUrl: string, invite_payload: string) {
        const apiTokenData = await response3.json();
        const apiToken = apiTokenData.api_trigger_token;
        if (apiToken) {
            const response4 = await fetch(endpoints.apiTrigger, {
                method: "POST",
                body: JSON.stringify({
                    email_id: data.email_id,
                    workflow_design_time_id: workflowId,
                    user_id: data.user_id,
                    token: data.system_access_token,
                    plan_id: planId || localStorage.getItem("planId") || "",
                    return_url: returnUrl,
                    invite_payload: invite_payload
                }),
                headers: {
                    Accept: "application.json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${apiToken}`
                }
            });
            const apiTriggerResponse = await response4.json();
            if (response4.status === 200) {
                window.open(apiTriggerResponse.redirectUrl, "_self");
            }
        }
    }

    const updateThriveStack = (userId: string) => {
        try {
            if (window.thriveStack && typeof window.thriveStack.setUserId === 'function') {
                window.thriveStack.setUserId(userId);
                
                return true;
            } 

            else if (window.ThriveStack && typeof window.ThriveStack.setUserId === 'function') {
                window.ThriveStack.setUserId(userId);
                
                return true;
            }
            return false;
        } catch (error) {
            console.error('Error:', error);
            return false;
        }
    };
    

    useEffect(() => {
        Cookies.remove("system_token");
        (async () => {
            const hash = location.hash.substring(1);
            if (hash.includes("access_token")) {
                let accessToken: any;
                // find access code
                const hashArray = hash.split("&");
                hashArray.forEach((element) => {
                    const params = element.split("=");
                    if (params[0] === "access_token") {
                        accessToken = params[1];
                        localStorage.setItem("access_token", accessToken);
                    }
                });
                // api call to validate access code
                const headers = new Headers();

                headers.append("Accept", "application.json");
                headers.append("Content-Type", "application/json");
                headers.append("Authorization", `Bearer ${accessToken}`);

                const invitedURL = localStorage.getItem("SessionRedirectURL");
                let isInvited = false;
                let invitedMailId = "";
                let redirectLoginURL = false;

                if (invitedURL && invitedURL.includes("productId")) {
                    const params = new URLSearchParams(new URL(invitedURL).search);
                    const prodIdValue = params.get("productId");
                    isInvited = params.get("isInvite");
                    invitedMailId = params.get("emailId");
                    headers.append("Invited-Product-Id", prodIdValue);
                }

                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                const returnUrl = urlParams.get("returnUrl") || "";
                const invite_payload = urlParams.get("invitePayload") || "";

                getUserByEmail({
                    variables: {
                        emailId: invitedMailId
                    },
                    onCompleted: async (userData: any) => {
                        console.log("userData", userData);
                        userData?.getUserByEmail?.stateFlags?.forEach((element: any) => {
                            if (element.key === "IS_ACTIVATED" && element.value === true) {
                                if ((isInvited === "true" || isInvited === true) && invitedURL) redirectLoginURL = true;
                            }
                        });
                        const response2 = await fetch(endpoints.loginWithIdpToken, {
                            method: "POST",
                            credentials: "include",
                            headers: headers
                        });
                        const data = await response2.json();
                        if (data.user_id) {
                            updateThriveStack(data.user_id);
                        }
                        localStorage.setItem("userDetails", data.user_id);
                        localStorage.setItem("system_token", data.system_access_token);
                        localStorage.setItem("access_token", data.system_access_token);
                        // redirect to next sub system
                        if (response2.status === 200) {
                            getUser({
                                variables: {
                                    userId: data.user_id
                                },
                                context: {
                                    headers: {
                                        Authorization: `Bearer ${data.system_access_token}`
                                    }
                                },



                                onCompleted: async (userData: any) => {
                                    console.log("userData", userData);

                                    userData.getUser.stateFlags.forEach((element: any) => {
                                        if (element.key === "IS_INVITED" && element.value === true) {
                                            if (redirectLoginURL) {
                                                window.open(invitedURL, "_self");
                                            } else {
                                                sendInviteeSignUpTrackEvent({
                                                    variables: {
                                                        input: {
                                                            inviteURL: invitedURL,
                                                            userId: data.user_id
                                                        }
                                                    },
                                                    onCompleted() {
                                                        window.open(
                                                            `${process.env.DOMAIN_URL}/on-boarding/welcome`,
                                                            "_self"
                                                        );
                                                    },
                                                    onError() {
                                                        window.open(
                                                            `${process.env.DOMAIN_URL}/on-boarding/welcome`,
                                                            "_self"
                                                        );
                                                    }
                                                });
                                            }

                                            console.log("redirect", element.value);
                                        }
                                    });
                                    if (isInvited === "true" || isInvited === true) {
                                        if (redirectLoginURL) {
                                            window.open(invitedURL, "_self");
                                        } else {
                                            sendInviteeSignUpTrackEvent({
                                                variables: {
                                                    input: {
                                                        inviteURL: invitedURL,
                                                        userId: data.user_id
                                                    }
                                                },
                                                onCompleted() {
                                                    window.open(
                                                        `${process.env.DOMAIN_URL}/on-boarding/welcome`,
                                                        "_self"
                                                    );
                                                },
                                                onError() {
                                                    window.open(
                                                        `${process.env.DOMAIN_URL}/on-boarding/welcome`,
                                                        "_self"
                                                    );
                                                }
                                            });
                                        }
                                    }
                                    setHostAuthenticationState();
                                    const response3 = await fetch(endpoints.apiToken, {
                                        method: "POST",
                                        body: JSON.stringify({
                                            expiry: EXPIRY_TIME
                                        }),
                                        headers: {
                                            Accept: "application.json",
                                            "Content-Type": "application/json",
                                            Authorization: `Bearer ${accessToken}`
                                        }
                                    });
                                    if (response3.status === 200) {
                                        let workflowId = "";

                                        if(sourceProduct == "SourceProduct_CustomerAnalytics"){
                                            workflowId = process.env.CUSTOMER_ANALYTICS_SINGUP_URL ?? "";
                                            APITrigger(data, response3, workflowId, returnUrl, invite_payload);
                                        } else {
                                            getWorkflowId({
                                                variables: {},
                                                context: {
                                                    headers: {
                                                        Authorization: `Bearer ${data.system_access_token}`
                                                    }
                                                },
                                                onCompleted: (workflowData: any) => {
                                                    const workflowId = workflowData.getThriveStackWorkflowSignupId?.workflowId;
                                                    APITrigger(data, response3, workflowId, returnUrl, invite_payload);
                                                },
                                                onError: (error) => {
                                                    console.log("error");
                                                }
                                            });
                                        }
                                    }
                                }
                            });
                        }
                    }
                });
            } else {
                setValid(false);
            }
        })();
    }, []);
    return (
        <div className="flex h-screen justify-center items-center flex-col">
            {valid ? (
                <h1 className="text-xl">{textConstants.VERIFY_AND_REDIRECT}</h1>
            ) : (
                <div>
                    <h1 className="text-xl mb-2">{textConstants.VERIFICATION_FAILD}</h1>
                    <p>{`Your link has expired. Please signup again to get a new signup link to continue.`}</p>
                    <a
                        className="font-bold cursor-pointer hover:underline text-[#6666FF]"
                        onClick={() => {
                            window.open(`${process.env.DOMAIN_URL}/auth/customer-analytics/sign-up`, "_self");
                        }}>{`Navigate to the sign-up page `}</a>
                    and you can restart from where you left off
                </div>
            )}
        </div>
    );
};
